import React,{useEffect,useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import {FaStamp} from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import NavDropdown from './NavDropdown';

const { FiMenu, FiX } = FiIcons;

const serviceAreaItems = [
  { label: 'Laurel, MD', href: '/mobile-notary/laurel' },
  { label: 'Aspen Hill, MD', href: '/mobile-notary/aspen-hill' },
  { label: 'Rockville, MD', href: '/mobile-notary/rockville' },
  { label: 'Gaithersburg, MD', href: '/mobile-notary/gaithersburg' },
  { label: 'See all service areas →', href: '/service-areas', divider: true, more: true }
];

const serviceItems = [
  { label: 'Mobile Notary', href: '/services/mobile-notary' },
  { label: 'Remote Online Notary', href: '/services/remote-online-notary' },
  { label: 'General Notarizations', href: '/services/general-notarizations' },
  { label: 'Apostille Services', href: '/services/apostille' },
  { label: 'See all services →', href: '/services', divider: true, more: true }
];

const Header=()=> {
  const [isScrolled,setIsScrolled]=useState(false);
  const [isMobileMenuOpen,setIsMobileMenuOpen]=useState(false);

  useEffect(()=> {
    const handleScroll=()=> setIsScrolled(window.scrollY > 80);

    handleScroll();
    window.addEventListener('scroll',handleScroll,{passive: true});

    return ()=> window.removeEventListener('scroll',handleScroll);
  },[]);

  return (
    <div className="h-20">
      <motion.header
        initial={false}
        animate={{
          top: isScrolled ? 14 : 0,
          width: isScrolled ? 'min(900px, calc(100% - 24px))' : '100%',
          height: isScrolled ? 64 : 80,
          borderRadius: isScrolled ? 999 : 0,
          boxShadow: isScrolled
            ? '0 14px 35px rgba(15, 27, 45, 0.16)'
            : '0 0 0 rgba(15, 27, 45, 0)',
          paddingLeft: isScrolled ? 16 : 0,
          paddingRight: isScrolled ? 16 : 0
        }}
        transition={{
          duration: 0.3,
          ease: [0.22,1,0.36,1]
        }}
        className="fixed left-1/2 z-50 -translate-x-1/2 overflow-visible border-b border-line bg-cream/90 backdrop-blur-md"
      >
        <div className="h-full flex items-center justify-between">
          <a href="/" className="flex items-center gap-3 group shrink-0">
            <motion.div
              animate={{
                width: isScrolled ? 30 : 32,
                height: isScrolled ? 30 : 32
              }}
              transition={{ duration: 0.3 }}
              className="rounded-full border border-brass flex items-center justify-center text-brass group-hover:bg-brass group-hover:text-cream transition-colors"
            >
              <SafeIcon icon={FaStamp} size={14} />
            </motion.div>
            <motion.span
              animate={{
                fontSize: isScrolled ? '1.35rem' : '1.5rem'
              }}
              transition={{ duration: 0.3 }}
              className="font-fraunces font-medium tracking-tight text-navy"
            >
              Pronto Notary
            </motion.span>
          </a>

          <nav className="hidden md:flex items-center gap-10 text-sm font-semibold tracking-wide text-navy/80">
            <NavDropdown label="Services" items={serviceItems} />
            <a href="/about" className="hover:text-brass transition-colors">
              About
            </a>
            <NavDropdown label="Service Areas" items={serviceAreaItems} />
            <a href="#faq" className="hover:text-brass transition-colors">
              FAQ
            </a>
          </nav>

          <div className="flex items-center gap-3 shrink-0">
            <a
              href="tel:2405713117"
              className="hidden sm:block border border-navy/30 text-navy px-4 py-2.5 rounded-full text-sm font-semibold hover:border-brass hover:text-brass transition-colors"
            >
              (240) 571-3117
            </a>
            <a
              href="/contact"
              className="hidden sm:block bg-navy text-cream px-6 py-2.5 rounded-full text-sm font-bold hover:bg-brass transition-colors"
            >
              Book
            </a>
            <button
              type="button"
              aria-label={isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
              aria-expanded={isMobileMenuOpen}
              onClick={() => setIsMobileMenuOpen((open) => !open)}
              className="md:hidden flex h-10 w-10 items-center justify-center rounded-full border border-navy/20 text-navy"
            >
              <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} size={19} />
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <nav className="md:hidden absolute left-0 right-0 top-full mt-3 rounded-2xl border border-line bg-cream p-4 text-sm font-semibold tracking-wide text-navy/80 shadow-[0_16px_35px_rgba(15,27,45,0.14)]">
            <div className="flex flex-col gap-4">
              <NavDropdown label="Services" items={serviceItems} mobile />
              <a href="/about" className="py-1 hover:text-brass transition-colors">
                About
              </a>
              <NavDropdown label="Service Areas" items={serviceAreaItems} mobile />
              <a href="#faq" className="py-1 hover:text-brass transition-colors">
                FAQ
              </a>
              <a href="/contact" className="mt-1 rounded-full bg-navy px-5 py-3 text-center text-cream hover:bg-brass transition-colors">
                Book Your Appointment
              </a>
            </div>
          </nav>
        )}
      </motion.header>
    </div>
  );
};

export default Header;